import { Observable } from 'rxjs';
import { ResponseFromServer, CommonDataModel } from '../../_models';
import { IHttpClient, HttpOptions } from '../http-client';
import { IServerHttpClient } from './server-http-client.interface';

export abstract class BaseServerHttpClient implements IServerHttpClient {
  protected baseUrl: string;

  constructor(
    protected httpClient: IHttpClient,
    baseUrl: string
  ) {
    this.baseUrl = baseUrl;
  }

  get<TResponse>(relativePath: string, options?: HttpOptions): Observable<ResponseFromServer<TResponse>> {
    return this.httpClient
      .get<ResponseFromServer<TResponse>>(this.buildAbsoluteUrl(relativePath), options);
  }

  post<TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<ResponseFromServer<TResponse>> {
    return this.httpClient
      .post<ResponseFromServer<TResponse>, TBody>(this.buildAbsoluteUrl(relativePath), body, options);
  }

  put<TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<ResponseFromServer<TResponse>> {
    return this.httpClient
      .put<ResponseFromServer<TResponse>, TBody>(this.buildAbsoluteUrl(relativePath), body, options);
  }

  delete<TResponse>(relativePath: string, options?: HttpOptions): Observable<ResponseFromServer<TResponse>> {
    return this.httpClient
      .delete<ResponseFromServer<TResponse>>(this.buildAbsoluteUrl(relativePath), options);
  }

  patch<TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<ResponseFromServer<TResponse>> {
    return this.httpClient
      .patch<ResponseFromServer<TResponse>, TBody>(this.buildAbsoluteUrl(relativePath), body, options);
  }

  get plain() {
    return {
      get: <TResponse>(relativePath: string, options?: HttpOptions): Observable<TResponse> =>
        this.httpClient.get<TResponse>(this.buildAbsoluteUrl(relativePath), options),

      post: <TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<TResponse> =>
        this.httpClient.post<TResponse, TBody>(this.buildAbsoluteUrl(relativePath), body, options),

      put: <TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<TResponse> =>
        this.httpClient.put<TResponse, TBody>(this.buildAbsoluteUrl(relativePath), body, options),

      delete: <TResponse>(relativePath: string, options?: HttpOptions): Observable<TResponse> =>
        this.httpClient.delete<TResponse>(this.buildAbsoluteUrl(relativePath), options),

      patch: <TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<TResponse> =>
        this.httpClient.patch<TResponse, TBody>(this.buildAbsoluteUrl(relativePath), body, options),
    };
  }

  abstract getExpanded<TResponse>(relativePath: string, options?: HttpOptions): Observable<CommonDataModel<TResponse>>;

  abstract postExpanded<TResponse, TBody>(relativePath: string, body: TBody, options?: HttpOptions): Observable<CommonDataModel<TResponse>>;

  protected buildAbsoluteUrl(relativePath: string): string {
    return `${this.baseUrl}/${relativePath}`;
  }
}
